import { Component, Input, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ZoningCodeService } from 'src/app/core/services';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';
import { TableType } from 'src/shared/enums';
import { LoaderService } from 'src/shared/services';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { ImportTableWorkflowBaseComponent } from '../shared/import-table-workflow.base';

export type TabularImportKind = 'general' | 'useCapacity';

@Component({
    standalone: false,
    selector: 'app-calibration-tabular-import-table',
    templateUrl: './calibration-tabular-import-table.component.html',
    styleUrls: ['./calibration-tabular-import-table.component.scss']

})
export class CalibrationTabularImportTableComponent extends ImportTableWorkflowBaseComponent<IZoningCodeModel> implements OnInit {
    @Input() kind: TabularImportKind;
    @Input() tableType: TableType;
    @Input() templateType: string;
    @Input() importConfirmationMessage: string;

    zoningCode: IZoningCodeModel = null;
    validationData: Observable<IZoningCodeModel>;
    private validationDataValue: IZoningCodeModel = null;
    private readonly validationDataSubject: BehaviorSubject<IZoningCodeModel> = new BehaviorSubject<IZoningCodeModel>(null);

    constructor(
        private readonly zoningCodeService: ZoningCodeService,
        loaderService: LoaderService,
        dialog: MatDialog,
        toastrService: ToastrService
    ) {
        super(loaderService, dialog, toastrService);
        this.validationData = this.validationDataSubject.asObservable();
    }

    ngOnInit(): void {
        this.loaderService.show();
        this.zoningCodeService.zoningCodes.pipe(filter(zc => zc !== null && zc.length > 0)).subscribe(zc => {
            this.zoningCode = zc[0];
            if (!this.zoningCode) {
                return;
            }
            this.loaderService.hide();
        });
    }

    clearTable(): void {
        this.selectedFileData = null;
        this.resetValidationData();
    }

    protected getValidationData(): IZoningCodeModel {
        return this.validationDataValue;
    }

    protected resetValidationData(): void {
        this.validationDataValue = null;
        this.validationDataSubject.next(null);
    }

    protected setValidationData(result: IZoningCodeModel): void {
        this.validationDataValue = null;
        this.validationDataSubject.next(null);
        setTimeout(() => {
            this.validationDataValue = result;
            this.validationDataSubject.next(result);
        }, 0);
    }

    protected getImportConfirmationMessage(): string {
        return this.importConfirmationMessage;
    }

    protected runValidationRequest(): Observable<IZoningCodeModel> {
        switch (this.kind) {
            case 'general':
                return this.zoningCodeService.validateZCmbGeneralValues(this.zoningCode.Id, this.selectedFileData);
            case 'useCapacity':
                return this.zoningCodeService.validateZCmbOfficeCommercialValues(this.zoningCode.Id, this.selectedFileData);
            default:
                throw new Error(`Unsupported tabular import kind: ${this.kind}`);
        }
    }

    protected runImportRequest(): Observable<any> {
        switch (this.kind) {
            case 'general':
                return this.zoningCodeService.importZCmbGeneralValues(this.zoningCode.Id, this.selectedFileData);
            case 'useCapacity':
                return this.zoningCodeService.importZCmbOfficeCommercialValues(this.zoningCode.Id, this.selectedFileData);
            default:
                throw new Error(`Unsupported tabular import kind: ${this.kind}`);
        }
    }
}
